/*
  NAVEE 定制：把指向 YouTube 的按钮改成页面内弹窗播放。
  标记由 snippets/button-link.liquid 输出（a[data-yt-lightbox="<videoId>"]），
  href 保留原链接，所以脚本没跑起来时按钮仍然是一个正常的外链。

  用原生 <dialog>：ESC 关闭、背景遮罩、焦点管理和还原都由浏览器负责。
*/
(function () {
  if (window.__naveeYtLightbox) return;
  window.__naveeYtLightbox = true;

  var dialog = null;
  var frame = null;

  function build() {
    if (dialog) return;

    dialog = document.createElement('dialog');
    dialog.className = 'yt-lightbox';
    dialog.innerHTML =
      '<div class="yt-lightbox__inner">' +
      // × 用两条伪元素画，粗细可控；用字符的话线宽跟着字体走，没法调细。
      '<button type="button" class="yt-lightbox__close" data-yt-close aria-label="Close"></button>' +
      '<div class="yt-lightbox__frame" data-yt-frame></div>' +
      '</div>';

    frame = dialog.querySelector('[data-yt-frame]');

    // 点遮罩关闭：dialog 自身的区域就是遮罩，内容在 __inner 里。
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog || event.target.closest('[data-yt-close]')) close();
    });

    // ESC 走的是 cancel/close，统一在 close 事件里清理 iframe。
    dialog.addEventListener('close', function () {
      frame.innerHTML = '';
    });

    document.body.appendChild(dialog);
  }

  function close() {
    if (dialog && dialog.open) dialog.close();
  }

  function open(videoId) {
    build();

    var iframe = document.createElement('iframe');
    // nocookie 域少放追踪 cookie，欧盟站点更省事。
    iframe.src =
      'https://www.youtube-nocookie.com/embed/' +
      encodeURIComponent(videoId) +
      '?autoplay=1&rel=0&playsinline=1';
    iframe.title = 'YouTube video player';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.setAttribute('frameborder', '0');

    frame.innerHTML = '';
    frame.appendChild(iframe);

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('a[data-yt-lightbox]');
    if (!trigger) return;

    // 新窗口打开、中键、右键等交给浏览器，不要拦。
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var videoId = trigger.dataset.ytLightbox;
    if (!videoId) return;

    event.preventDefault();
    open(videoId);
  });
})();
